const mq = gateway => ({
  publish(event, data = {}) {
    gateway.postMessage({ event, data });
  }
});

export default mq;
